module.exports = __webpack_public_path__ + "static/img/usinessPartner_03_m.fe89249a.jpg";